export default __webpack_public_path__ + "static/media/not_enabled_dental.7ea85217.png";